import { render } from "./ModalPaymentSuccess.vue?vue&type=template&id=752ced62&scoped=true&ts=true"
import script from "./ModalPaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./ModalPaymentSuccess.vue?vue&type=script&lang=ts"

import "./ModalPaymentSuccess.vue?vue&type=style&index=0&id=752ced62&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752ced62"]])

export default __exports__